import React, { useEffect, useState } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import PropTypes from 'prop-types';
import getFinalAttribute from 'utils/alternative-attribute';
import { isEmpty } from 'lodash';

function HotelPageSubMenu({
    hasPictures, headerHeight, hotel, hideOffers, hideMap, clusters,
})
{
    const [style, setStyle] = useState('');

    useEffect(() => setStyle('submenu-sticky'), []);

    return (
        <nav className={`tw-bg-gray-100 ${style}`} style={{ top: headerHeight }}>
            <div className="tw-w-full tw-text-center tw-px-4 tw-py-2 lg:tw-pt-4 lg:tw-pb-6 tw-shadow-xl">
                <div className="tw-flex tw-justify-between">
                    <div className="tw-w-full">
                        <h1 className="tw-font-normal font-arapey tw-text-gray-700 tw-text-2xl tw-my-2">{getFinalAttribute(hotel, 'name')}</h1>
                        <AnchorLink offset="100" href="#overview">
                            <span className="tw-uppercase font-sp tw-mr-5 tw-hidden lg:tw-inline hover:tw-text-orange-400">Overview</span>
                        </AnchorLink>
                        {hasPictures
                            && (
                                <>
                                    <span className="tw-rounded-full tw-h-1 tw-w-1 tw-bg-gray-700 tw-inline-block tw-align-middle tw-hidden lg:tw-inline-block" />
                                    <AnchorLink offset="100" href="#gallery">
                                        <span className="tw-uppercase font-sp tw-mx-5 tw-hidden lg:tw-inline hover:tw-text-orange-400">Gallery</span>
                                    </AnchorLink>
                                </>
                            )}

                        {!hideOffers && (
                            <>
                                <span className="tw-rounded-full tw-h-1 tw-w-1 tw-bg-gray-700 tw-inline-block tw-align-middle tw-hidden lg:tw-inline-block" />

                                <AnchorLink offset="100" href="#offers">
                                    <span className="tw-uppercase font-sp tw-mx-5 tw-hidden lg:tw-inline hover:tw-text-orange-400">Offers</span>
                                </AnchorLink>
                            </>

                        )}

                        {!isEmpty(hotel.hotelRooms) && (
                        <>
                            <span className="tw-rounded-full tw-h-1 tw-w-1 tw-bg-gray-700 tw-inline-block tw-align-middle tw-hidden lg:tw-inline-block" />
                            <AnchorLink offset="100" href="#rooms">
                                <span className="tw-uppercase font-sp tw-mx-5 tw-hidden lg:tw-inline hover:tw-text-orange-400">Rooms</span>
                            </AnchorLink>
                        </>
                        )
                        }


                        {!isEmpty(clusters) && (
                            <>
                                <span className="tw-rounded-full tw-h-1 tw-w-1 tw-bg-gray-700 tw-inline-block tw-align-middle tw-hidden lg:tw-inline-block" />
                                <AnchorLink offset="100" href="#clusters">
                                    <span className="tw-uppercase font-sp tw-mx-5 tw-hidden lg:tw-inline hover:tw-text-orange-400">More Information</span>
                                </AnchorLink>
                            </>
                        )
                        }

                        {(hotel.geo_longitude != null && hotel.geo_latitude && !hideMap) && (
                            <>
                                <span className="tw-rounded-full tw-h-1 tw-w-1 tw-bg-gray-700 tw-inline-block tw-align-middle tw-hidden lg:tw-inline-block" />
                                <AnchorLink offset="200" href="#map">
                                    <span className="tw-uppercase font-sp tw-ml-5 tw-hidden lg:tw-inline hover:tw-text-orange-400">Map</span>
                                </AnchorLink>
                                </>
                        )
                        }
                    </div>
                </div>
            </div>
        </nav>
    );
}

HotelPageSubMenu.propTypes = {
    hasPictures: PropTypes.bool.isRequired,
    headerHeight: PropTypes.number,
    hotel: PropTypes.object.isRequired,
    hideOffers: PropTypes.bool,
    hideMap: PropTypes.bool,
    clusters: PropTypes.array,
};

export default HotelPageSubMenu;
